import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "react-router-dom";

interface NoteWorksheetSuccessProps {
  props?: any;
}

const NoteWorksheetSuccess = ({ props }: NoteWorksheetSuccessProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-12 text-center px-4 md:px-8 py-16">
      {/* Thank You Section */}
      <div className="flex flex-col items-center justify-center gap-4">
        <h1 className="text-3xl md:text-4xl font-bold text-black">Thank You</h1>
        <div className="w-24 h-1 bg-accent"></div>
      </div>

      {/* Blurb Section */}
      <div className="max-w-3xl text-main-gray">
        <p className="text-lg leading-relaxed">
          An email has been sent to you with your submission data.
        </p>
        <p className="text-lg leading-relaxed mt-4">
          By utilizing our Online Note Worksheet and providing us with the
          necessary information to begin the evaluation process, our team of
          experienced note-buying professionals will carefully review your
          submission and provide a fair assessment of your note's value.
        </p>
        <p className="text-lg leading-relaxed mt-4">
          We appreciate the time you took to complete the form and are committed
          to delivering your free note analysis in a timely manner. Whether
          you're looking to sell a residential or commercial note, performing or
          non-performing, we have the knowledge and expertise to guide you
          through the process to come and look forward to working with you!
        </p>
      </div>

      <Link to="/online-note-worksheet">
        <button className="btn btn-accent border-none text-white">
          Submit Another Note
        </button>
      </Link>

      {/* Cards Section */}
      <div className="w-full max-w-5xl">
        <h2 className="text-2xl font-bold text-black mb-8">
          Explore Our Note Buying Options
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Secured Investment Corps Notes Card */}
          <div className="card bg-white shadow-xl hover:shadow-2xl transition-all duration-300">
            <div className="card-body">
              <h3 className="card-title text-xl font-bold text-black">
                <img
                  src="/SIC_Favicon.png"
                  alt="Secured Investment Corps Notes"
                  className="w-[40px] h-[40px] object-cover"
                />
                Secured Investment Corp's Notes
              </h3>
              <p className="text-main-gray">
                Discover our premium selection of secure investment
                opportunities with our professionally vetted mortgage notes.
              </p>
              <div className="card-actions justify-end mt-4">
                <Link
                  to="/"
                  className="btn bg-[#16497D] hover:bg-[#16497D] border-none text-white"
                >
                  Explore Notes{" "}
                  <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                </Link>
              </div>
            </div>
          </div>

          {/* Income Note Exchange Card */}
          <div className="card bg-white shadow-xl hover:shadow-2xl transition-all duration-300">
            <div className="card-body">
              <h3 className="card-title text-xl font-bold text-black">
                <img
                  src="/IN_Favicon.png"
                  alt="Secured Investment Corps Notes"
                  className="w-[40px] h-[50px] object-cover"
                />
                Income Note Exchange
              </h3>
              <p className="text-main-gray">
                Access our marketplace for income-producing notes and discover
                opportunities to diversify your investment portfolio.
              </p>
              <div className="card-actions justify-end mt-4">
                <a
                  href="https://www.incomenoteexchange.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn bg-[#D2EB59] hover:bg-[#D2EB59] border-none text-black"
                >
                  Visit Exchange{" "}
                  <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteWorksheetSuccess;
